export default {
    name: "BL Subscription List",
    meta: {
        icon: "directions_boat",
        expanded: true,
        auth: true,
    },
    departmentName: "BL Subscription List",
    finalPagePermision: "Bl_Subs_Dash",
    children: [{
        name: "BL Subscription List Details",
        path: "/bl-subs-list",
        permissionName: 'Bl_Subs_Dash',
        keywords: ['BL Subscription List Details ', 'Bl_Subs_Dash'],
        meta: {
            icon: "directions_boat",
            auth: true,
        },
        component: require("../component/blFreight/blSubsListPending.vue"),
        finalPagePermision: "Bl_Subs_Dash",
    }, ],
};


// WEBPACK FOOTER //
// ./src/sidebar/blSubscription.js